import CmsWorker from './cmsWorker';

// This is to avoid re-runs if the JS file is used multiple times
const CMSDynamicFetchingEnabled = window.CMSDynamicFetchingEnabled;
async function cmsDynamicFetching() {
  if (!CMSDynamicFetchingEnabled) {
    window.CMSDynamicFetchingEnabled = true;
    const cmsWorker = new CmsWorker();
    const loadPreferencesCallback = await cmsWorker.init();
    if (document.readyState === 'complete') {
      await loadPreferencesCallback();
    } else {
      document.addEventListener('DOMContentLoaded', loadPreferencesCallback);
    }
  }
}
cmsDynamicFetching();